var isNative = require('../lang/isNative');

/** Native method references. */
var WeakMap = isNative(WeakMap = global.WeakMap) && WeakMap;

/** Used to store function metadata. */
var metaMap = WeakMap && new WeakMap;

module.exports = metaMap;



/*****************
 ** WEBPACK FOOTER
 ** ./~/lodash/internal/metaMap.js
 ** module id = 967
 ** module chunks = 0
 **/